import axios from "axios";
import { SurveyStatus } from "../../../modules/constants";

//Constants
const SET_SURVEY_DATA = "SET_SURVEY_DATA";
const RESET_STATE = "RESET_STATE";

//Acessors
const getSurveyData = (state) => state?.surveyData;

const initialState = {
  surveyData: null,
};

export const clinicalSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SURVEY_DATA:
      const { data } = action;
      return {
        ...state,
        surveyData: data,
      };
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

const fetchSurvey = (surveyId, token) => (dispatch) => {
  return axios
    .get(`/api/survey/definition/participant/${surveyId}`)
    .then(({ data }) => dispatch({ type: SET_SURVEY_DATA, data }))
    .catch((e) => {
      return Promise.reject("The content is not available.");
    });
};

const sendSurveyResponse = (surveyId, model) => (dispatch) => {
  const params = {
    surveyDefinitionId: surveyId,
    model,
    status: SurveyStatus.COMPLETED.id,
  };
  return axios
    .post(`/api/survey/response`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((e) => {
      return Promise.reject(e?.response?.data ?? "This survey has expired.");
    });
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    surveyData: getSurveyData(state),
  };
};

export const mapDispatchToProps = {
  fetchSurvey,
  sendSurveyResponse,
  resetState,
};
